// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_bZF","cls2":"SuggestedUserCard-cls2_avW SuggestedUserCard-cls1_bZF"};